import { render, staticRenderFns } from "./PmwHotelNav.vue?vue&type=template&id=13608558&scoped=true&"
import script from "./PmwHotelNav.vue?vue&type=script&lang=js&"
export * from "./PmwHotelNav.vue?vue&type=script&lang=js&"
import style0 from "./PmwHotelNav.vue?vue&type=style&index=0&id=13608558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13608558",
  null
  
)

export default component.exports